// src/services/pushNativoService.ts
//
// Registro de notificação push nativa (Firebase Cloud Messaging) quando o
// sistema roda dentro do app Android empacotado com Capacitor. Não faz nada
// quando acessado por um navegador normal (Capacitor.isNativePlatform()
// retorna false nesse caso) — o site continua funcionando exatamente igual.
//
// Isso só registra o dispositivo e guarda o token; o disparo de notificações
// a partir do servidor é um passo separado (Edge Function com Firebase Admin
// SDK), ainda não implementado.

import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { supabase } from '../lib/supabase';

let jaInicializado = false;

async function salvarToken(email: string, token: string): Promise<void> {
  const { error } = await supabase
    .from('dispositivo_push_token')
    .upsert(
      { email: email.trim().toLowerCase(), fcm_token: token, plataforma: Capacitor.getPlatform(), ativo: true, updated_at: new Date().toISOString() },
      { onConflict: 'email,fcm_token' },
    );
  if (error) {
    console.warn('Erro ao salvar token de notificação push:', error.message);
  }
}

/**
 * Chame depois do login (qualquer portal — staff, cliente ou motorista).
 * Só tem efeito dentro do app Android nativo.
 */
export async function registrarPushNativo(email: string | null | undefined): Promise<void> {
  if (!email) return;
  if (!Capacitor.isNativePlatform()) return; // navegador comum: não faz nada
  if (jaInicializado) return;
  jaInicializado = true;

  try {
    let permissao = await PushNotifications.checkPermissions();
    if (permissao.receive !== 'granted') {
      permissao = await PushNotifications.requestPermissions();
    }
    if (permissao.receive !== 'granted') {
      console.warn('Usuário negou permissão de notificação push.');
      return;
    }

    await PushNotifications.register();

    PushNotifications.addListener('registration', (token) => {
      salvarToken(email, token.value);
    });

    PushNotifications.addListener('registrationError', (err) => {
      console.warn('Erro ao registrar push notification nativa:', err);
    });

    // Notificação recebida com o app aberto (foreground) — por enquanto só
    // loga; cada tela pode decidir mostrar um toast próprio futuramente.
    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('Notificação push recebida em primeiro plano:', notification);
    });

    // Usuário tocou na notificação (app em segundo plano ou fechado).
    PushNotifications.addListener('pushNotificationActionPerformed', (acao) => {
      console.log('Usuário abriu a notificação:', acao.notification);
    });
  } catch (err) {
    console.warn('Erro ao inicializar notificação push nativa:', err);
  }
}
